import ProfileVerificationError from "./ProfileVerificationError"

export default class RequireRecaptchaVerificationError extends ProfileVerificationError {
  message = "No bots, please."
  verificationType = "recaptcha"
}
